<div class="contains-button">
    <!-- Hiển thị tiêu đề mở rộng -->
    <div class="editor-header" *ngIf="isViewAll">
        <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
        <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate}} </span>
    </div>

    <ng-container *ngIf="!isViewAll">
        <app-position-out-config [elementChoosing]="objectChoosing" [device]="device"
            [id_parent_choose]="objectChoosing.id_block? objectChoosing.id_block: objectChoosing.id_object">
        </app-position-out-config>

        <app-width-height-config [device]="device" [elementChoosing]="objectChoosing" 
            [width]="class['noti-order-success']['width']" [height]="class['noti-order-success']['height']"
            (changeWidthHeight)="changeWidthHeight($event)">
        </app-width-height-config>
        <ul nz-menu nzMode="inline">
            <!-- Lựa chọn hiển thị cho các thiết bị -->
            <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu3"
                (nzOpenChange)="openHandler('menu3')">
                <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
                </app-hide-show-config>
            </li>
            <!-- Cấu hình format font name của button -->
            <li nz-submenu nzTitle="{{'noi_dung_va_dinh_dang' | translate}}" [(nzOpen)]="openMap.menu1"
                (nzOpenChange)="openHandler('menu1')">
                <div class="ml-2">
                    <ng-container *ngFor="let itemCF of contentFields; let i = index; trackBy: trackByEditContentFormat">
                        <li nz-submenu [nzTitle]="itemCF.label | translate" [(nzOpen)]="openMapSub['submenu' + (i + 1)]"
                            (nzOpenChange)="openHandler('submenu' + (i + 1), true)">
                            <div class="container-font">
                                <div class="config-text" style="width: 100%">
                                    <ng-container *ngFor="let itemF of itemCF.fields; let i2 = index; trackBy: trackByEditContent">
                                        <!-- Nhập nội dung của nút -->
                                        <mat-form-field style="width: 100%">
                                            <mat-label> {{ itemF.label | translate }}</mat-label>
                                            <textarea matInput *ngIf="itemF.isLang"
                                                [ngModel]="staticdata[itemF.field + '_' + functionService.selectedLanguageCode] | vhLanguage : itemF.field"
                                                (ngModelChange)="staticdata[itemF.field + '_' + functionService.selectedLanguageCode] = $event"
                                                (blur)="updateStaticData()">
                                            </textarea>
                                            <textarea matInput *ngIf="!itemF.isLang"
                                                [ngModel]="staticdata[itemF.field] || ''"
                                                (ngModelChange)="staticdata[itemF.field] = $event"
                                                (blur)="updateStaticData()">
                                            </textarea>
                                        </mat-form-field>
                                    </ng-container>
                                </div>

                                <ng-container *ngIf="itemCF.classField">
                                    <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                                        [config]="config" [staticdata]="staticdata" [textContentClass]="class[itemCF.classField]"
                                        [textWrapperClass]="class[itemCF.classField]">
                                    </app-text-format-config>
                                    <!-- Khoảng cách chữ -->
                                    <app-letter-spacing-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                                        [classLetterSpacing]="class[itemCF.classField]" (updateClass)="updateClass()">
                                    </app-letter-spacing-config>
                                    <!-- Khoảng cách dòng -->
                                    <app-line-height-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                                        [classLineHeight]="class[itemCF.classField]" (updateClass)="updateClass()">
                                    </app-line-height-config>
                                </ng-container>
                            </div>
                        </li>
                    </ng-container>
                </div>
            </li>
            <!-- Cấu hình đổ bóng -->
            <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMap.menu5"
                (nzOpenChange)="openHandler('menu5')">
                <app-shadow-config [device]="device" [config]="config" [class]="class" 
                    [shadowClass]="class['noti-order-success']" [shadowConfig]="config['box-shadow']"
                    [objectChoosing]="objectChoosing">
                </app-shadow-config>
            </li>
            <!-- Cấu hình viền -->
            <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu6"
                (nzOpenChange)="openHandler('menu6')">
                <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                    [borderClass]="class['noti-order-success']" [id_object]="objectChoosing._id">
                </app-borders-config>
            </li>
            <!-- Cấu hình bo góc -->
            <li nz-submenu nzTitle="{{'bo_goc' | translate}}" [(nzOpen)]="openMap.menu7"
                (nzOpenChange)="openHandler('menu7')">
                <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                    [borderRadiusClass]="class['noti-order-success']" [id_object]="objectChoosing._id">
                </app-borders-radius-config>
            </li>
            <!-- Cấu hình màu nền -->
            <li nz-submenu nzTitle="{{'mau_nen' | translate}}" [(nzOpen)]="openMap.menu8"
                (nzOpenChange)="openHandler('menu8')">
                <div class="d-flex align-items-center justify-content-between">
                    <span class="w-50">Header</span>
                    <input class="input-color w-50" type="button" [cpOKButton]="true"
                        [(colorPicker)]="class['noti-order-success__header']['background-color']"
                        [style.background]="class['noti-order-success__header']['background-color']" 
                        (colorPickerClose)="updateClass()"
                        [cpWidth]="'230px'" 
                        [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                        [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                        [cpPresetLabel]="'bang_mau_mau' | translate" 
                        [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate" 
                        [cpPresetColors]="themeService.themeColors"
                        (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                        (colorPickerOpen)="themeService.onPickerColorOpen($event)" 
                    />
                </div>
                <div class="d-flex align-items-center justify-content-between mt-2">
                    <span class="w-50">{{'nen' | translate}}</span>
                    <input class="input-color w-50" type="button" [cpOKButton]="true"
                        [(colorPicker)]="class['noti-order-success']['background-color']"
                        [style.background]="class['noti-order-success']['background-color']" 
                        (colorPickerClose)="updateClass()"
                        [cpWidth]="'230px'" 
                        [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                        [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                        [cpPresetLabel]="'bang_mau_mau' | translate" 
                        [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate" 
                        [cpPresetColors]="themeService.themeColors"
                        (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                        (colorPickerOpen)="themeService.onPickerColorOpen($event)" 
                    />
                </div>
            </li>
            <!-- Cấu hình khoảng cách dưới -->
            <li nz-submenu nzTitle="{{'khoang_cach_duoi' | translate}}" [(nzOpen)]="openMap.menu9"
                (nzOpenChange)="openHandler('menu9')">
                <div class="border-bottom border-secondary">
                    <p>{{ 'mo_ta' | translate }}</p>
                    <app-margin-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                        [classMargin]="class['noti-order-success__desc']" 
                        [marginConfigs]="[{ type: 'bottom' }]">
                    </app-margin-config>
                </div>
                <div class="border-bottom border-secondary mt-2">
                    <p>{{ 'vien_duoi_mo_ta' | translate }}</p>
                    <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                        [classPadding]="class['noti-order-success__desc']"
                        [paddingConfigs]="[{ type: 'bottom' }]">
                    </app-padding-config>
                </div>
                <div class="border-bottom border-secondary mt-2">
                    <p>{{ 'phan' | translate }}</p>
                    <app-margin-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                        [classMargin]="class['noti-order-success__section']"
                        [marginConfigs]="[{ type: 'bottom' }]">
                    </app-margin-config>
                </div>
                <div class="border-bottom border-secondary mt-2">
                    <p>{{ 'vien_duoi_phan' | translate }}</p>
                    <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                        [classPadding]="class['noti-order-success__section']"
                        [paddingConfigs]="[{ type: 'bottom' }]">
                    </app-padding-config>
                </div>
                <div class="border-bottom border-secondary mt-2">
                    <p>{{ 'tieu_de_phan' | translate }}</p>
                    <app-margin-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                        [classMargin]="class['noti-order-success__section-title']"
                        [marginConfigs]="[{ type: 'bottom' }]">
                    </app-margin-config>
                </div>
                <div class="border-bottom border-secondary mt-2">
                    <p>{{ 'ten_san_pham' | translate }}</p>
                    <app-margin-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                        [classMargin]="class['noti-order-success__product-name']"
                        [marginConfigs]="[{ type: 'bottom' }]">
                    </app-margin-config>
                </div>
                <div class="mt-2">
                    <p>{{ 'so_luong_va_gia' | translate }}</p>
                    <app-margin-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                        [classMargin]="class['noti-order-success__product-meta']"
                        [marginConfigs]="[{ type: 'bottom' }]">
                    </app-margin-config>
                </div>
            </li>
            <!-- Cấu hình viền dưới ngăn cách -->
            <li nz-submenu nzTitle="{{'vien_ngan_cach' | translate}}" [(nzOpen)]="openMap.menu10"
                (nzOpenChange)="openHandler('menu10')">
                <div class="border-bottom border-secondary">
                    <span class="w-50">{{'duoi_mo_ta' | translate}}</span>
                    <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                        [borderClass]="class['noti-order-success__desc']" [id_object]="objectChoosing._id"
                        [borderConfigWidth]="['bottom']">
                    </app-borders-config>
                </div>
                <div class="mt-2">
                    <span class="w-50">{{'duoi_cac_phan' | translate}}</span>
                    <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                        [borderClass]="class['noti-order-success__section']" [id_object]="objectChoosing._id"
                        [borderConfigWidth]="['bottom']">
                    </app-borders-config>
                </div>
            </li>
            <!-- Cấu hình biểu tượng -->
            <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}" [(nzOpen)]="openMap.menu11"
                (nzOpenChange)="openHandler('menu11')">
                <div class="d-flex align-items-center justify-content-between">
                    <span class="w-50" style="line-height: 1.4;">
                        {{ 'mau_bieu_tuong' | translate }}
                    </span>
                    <input class="input-color w-50" type="button" [cpOKButton]="true"
                        [(colorPicker)]="class['noti-order-success__icon-check']['color']"
                        [style.background]="class['noti-order-success__icon-check']['color']" 
                        (colorPickerClose)="updateClass()"
                        [cpWidth]="'230px'" 
                        [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                        [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                        [cpPresetLabel]="'bang_mau_mau' | translate" 
                        [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate" 
                        [cpPresetColors]="themeService.themeColors"
                        (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                        (colorPickerOpen)="themeService.onPickerColorOpen($event)" 
                    />
                </div>
                <div class="d-flex align-items-center justify-content-between mt-2">
                    <span class="w-50" style="line-height: 1.4;">
                        {{ 'mau_nen' | translate }}
                    </span>
                    <input class="input-color w-50" type="button" [cpOKButton]="true"
                        [(colorPicker)]="class['noti-order-success__icon-check']['background-color']"
                        [style.background]="class['noti-order-success__icon-check']['background-color']" 
                        (colorPickerClose)="updateClass()"
                        [cpWidth]="'230px'" 
                        [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                        [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                        [cpPresetLabel]="'bang_mau_mau' | translate" 
                        [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate" 
                        [cpPresetColors]="themeService.themeColors"
                        (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                        (colorPickerOpen)="themeService.onPickerColorOpen($event)" 
                    />
                </div>
                <div class="d-flex align-items-center justify-content-between mt-2">
                    <span class="w-50" style="line-height:1.4;">
                        {{ 'chieu_dai' | translate }}
                    </span>
                    <nz-input-number class="w-50"
                        [nzMin]="0" [nzStep]="1"
                        [ngStyle]="{ marginLeft: '16px', width: '40%' }"
                        [ngModel]="class['noti-order-success__icon-check'].width | vhnumber"
                        (ngModelChange)="class['noti-order-success__icon-check'].width = $event + 'px'"
                        (nzBlur)="updateClass()">
                    </nz-input-number>
                </div>
                <div class="d-flex align-items-center justify-content-between mt-2">
                    <span class="w-50" style="line-height:1.4;">
                        {{ 'chieu_cao' | translate }}
                    </span>
                    <nz-input-number class="w-50"
                        [nzMin]="0" [nzStep]="1"
                        [ngStyle]="{ marginLeft: '16px', width: '40%' }"
                        [ngModel]="class['noti-order-success__icon-check'].height | vhnumber"
                        (ngModelChange)="class['noti-order-success__icon-check'].height = $event + 'px'"
                        (nzBlur)="updateClass()">
                    </nz-input-number>
                </div>
            </li>
            <li nz-submenu nzTitle="{{'canh_le_header' | translate}}" [(nzOpen)]="openMap.menu12"
                (nzOpenChange)="openHandler('menu12')">
                <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                    [classPadding]="class['noti-order-success__header']" [paddingConfigs]="[
                    { type: 'top' },
                    { type: 'bottom' },
                ]">
                </app-padding-config>
            </li>
            <li nz-submenu nzTitle="{{'canh_le' | translate}}" [(nzOpen)]="openMap.menu14"
                (nzOpenChange)="openHandler('menu14')">
                <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                    [classPadding]="class['noti-order-success__body']" [paddingConfigs]="[
                    { type: 'top' },
                    { type: 'bottom' },
                    { type: 'left' },
                    { type: 'right' }
                ]">
                </app-padding-config>
            </li>
        </ul>
    </ng-container>

    <!-- Xem chi tiết cấu hình object -->
    <div class="view-more" *ngIf="isViewAll">
        <!-- Cấu hình chi tiết viền -->
        <!-- <div class="view_more-border" *ngIf="currentViewAll.index == 2">
            <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                [borderRadiusClass]="class['button']" [id_object]="objectChoosing._id">
            </app-borders-radius-config>
        </div> -->
    </div>
</div>